import { render, staticRenderFns } from "./FontAwesomeIcon.vue?vue&type=template&id=436565ce&"
import script from "./FontAwesomeIcon.vue?vue&type=script&lang=js&"
export * from "./FontAwesomeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ui-spec-md/ui-spec-md/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('436565ce', component.options)
    } else {
      api.reload('436565ce', component.options)
    }
    module.hot.accept("./FontAwesomeIcon.vue?vue&type=template&id=436565ce&", function () {
      api.rerender('436565ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/FontAwesomeIcon.vue"
export default component.exports